import { registerCountryPlugin } from '@/core/plugins/country-plugin'
import TaiwanCheckoutModule from './modules/checkout/checkout.module'
import TaiwanPaymentsModule from './modules/payments/payments.module'
import TaiwanReviewModule from './modules/review/review.module'

registerCountryPlugin({
    slug: 'taiwan',
    code: 'TWN',
    CheckoutModule: TaiwanCheckoutModule,
    PaymentsModule: TaiwanPaymentsModule,
    ReviewModule: TaiwanReviewModule
})
